'use strict';

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var debug = require('debug');

var log = Object.assign(debug('libp2p:auto-relay'), {
  error: debug('libp2p:auto-relay:err')
});

var _require = require('uint8arrays/from-string'),
    uint8ArrayFromString = _require.fromString;

var _require2 = require('uint8arrays/to-string'),
    uint8ArrayToString = _require2.toString;

var _require3 = require('multiaddr'),
    Multiaddr = _require3.Multiaddr;

var PeerId = require('peer-id');

var _require4 = require('./multicodec'),
    multicodec = _require4.relay;

var _require5 = require('./circuit/hop'),
    canHop = _require5.canHop;

var _require6 = require('./utils'),
    namespaceToCid = _require6.namespaceToCid;

var _require7 = require('./constants'),
    CIRCUIT_PROTO_CODE = _require7.CIRCUIT_PROTO_CODE,
    HOP_METADATA_KEY = _require7.HOP_METADATA_KEY,
    HOP_METADATA_VALUE = _require7.HOP_METADATA_VALUE,
    RELAY_RENDEZVOUS_NS = _require7.RELAY_RENDEZVOUS_NS;
/**
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('../peer-store/address-book').Address} Address
 */

/**
 * @typedef {Object} AutoRelayProperties
 * @property {import('../')} libp2p
 *
 * @typedef {Object} AutoRelayOptions
 * @property {number} [maxListeners = 1] - maximum number of relays to listen.
 * @property {(error: Error, msg?: string) => {}} [onError]
 */


var AutoRelay = /*#__PURE__*/function () {
  /**
   * Creates an instance of AutoRelay.
   *
   * @class
   * @param {AutoRelayProperties & AutoRelayOptions} props
   */
  function AutoRelay(_ref) {
    var libp2p = _ref.libp2p,
        _ref$maxListeners = _ref.maxListeners,
        maxListeners = _ref$maxListeners === void 0 ? 1 : _ref$maxListeners,
        onError = _ref.onError;

    _classCallCheck(this, AutoRelay);

    this._libp2p = libp2p;
    this._peerId = libp2p.peerId;
    this._peerStore = libp2p.peerStore;
    this._connectionManager = libp2p.connectionManager;
    this._transportManager = libp2p.transportManager;
    this._addressSorter = libp2p.dialer.addressSorter;
    this.maxListeners = maxListeners;
    /**
     * @type {Set<string>}
     */

    this._listenRelays = new Set();
    this._onProtocolChange = this._onProtocolChange.bind(this);
    this._onPeerDisconnected = this._onPeerDisconnected.bind(this);

    this._peerStore.on('change:protocols', this._onProtocolChange);

    this._connectionManager.on('peer:disconnect', this._onPeerDisconnected);
    /**
     * @param {Error} error
     * @param {string} [msg]
     */


    this._onError = function (error, msg) {
      log.error(msg || error);
      onError && onError(error, msg);
    };
  }
  /**
   * Check if a peer supports the relay protocol.
   * If the protocol is not supported, check if it was supported before and remove it as a listen relay.
   * If the protocol is supported, check if the peer supports **HOP** and add it as a listener if
   * inside the threshold.
   *
   * @param {Object} props
   * @param {PeerId} props.peerId
   * @param {string[]} props.protocols
   * @returns {Promise<void>}
   */


  _createClass(AutoRelay, [{
    key: "_onProtocolChange",
    value: function () {
      var _onProtocolChange2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var peerId, protocols, id, hasProtocol, connection, supportsHop;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                peerId = _ref2.peerId, protocols = _ref2.protocols;
                id = peerId.toB58String(); // Check if it has the protocol

                hasProtocol = protocols.find(function (protocol) {
                  return protocol === multicodec;
                }); // If no protocol, check if we were keeping the peer before as a listenRelay

                if (!(!hasProtocol && this._listenRelays.has(id))) {
                  _context.next = 8;
                  break;
                }

                this._removeListenRelay(id);

                return _context.abrupt("return");

              case 8:
                if (!(!hasProtocol || this._listenRelays.has(id))) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                _context.prev = 10;
                connection = this._connectionManager.get(peerId);

                if (connection) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return");

              case 14:
                if (!connection.remoteAddr.protoCodes().includes(CIRCUIT_PROTO_CODE)) {
                  _context.next = 17;
                  break;
                }

                log("relayed connection to ".concat(id, " will not be used to hop on"));
                return _context.abrupt("return");

              case 17:
                _context.next = 19;
                return canHop({
                  connection: connection
                });

              case 19:
                supportsHop = _context.sent;

                if (!supportsHop) {
                  _context.next = 24;
                  break;
                }

                this._peerStore.metadataBook.set(peerId, HOP_METADATA_KEY, uint8ArrayFromString(HOP_METADATA_VALUE));

                _context.next = 24;
                return this._addListenRelay(connection, id);

              case 24:
                _context.next = 29;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context["catch"](10);

                this._onError(_context.t0);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[10, 26]]);
      }));

      function _onProtocolChange(_x) {
        return _onProtocolChange2.apply(this, arguments);
      }

      return _onProtocolChange;
    }()
    /**
     * Peer disconnects.
     *
     * @param {Connection} connection - connection to the peer
     * @returns {void}
     */

  }, {
    key: "_onPeerDisconnected",
    value: function _onPeerDisconnected(connection) {
      var peerId = connection.remotePeer;
      var id = peerId.toB58String(); // Not listening on this relay

      if (!this._listenRelays.has(id)) {
        return;
      }

      this._removeListenRelay(id);
    }
    /**
     * Attempt to listen on the given relay connection.
     *
     * @private
     * @param {Connection} connection - connection to the peer
     * @param {string} id - peer identifier string
     * @returns {Promise<void>}
     */

  }, {
    key: "_addListenRelay",
    value: function () {
      var _addListenRelay2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(connection, id) {
        var remoteAddrs, listenAddr;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this._listenRelays.size >= this.maxListeners)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                // Get peer known addresses and sort them per public addresses first
                remoteAddrs = this._peerStore.addressBook.getMultiaddrsForPeer(connection.remotePeer, this._addressSorter);

                if (!(!remoteAddrs || !remoteAddrs.length)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                listenAddr = "".concat(remoteAddrs[0].toString(), "/p2p-circuit");

                this._listenRelays.add(id); // Attempt to listen on relay


                _context2.prev = 7;
                _context2.next = 10;
                return this._transportManager.listen([new Multiaddr(listenAddr)]);

              case 10:
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](7);

                this._onError(_context2.t0);

                this._listenRelays.delete(id);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 12]]);
      }));

      function _addListenRelay(_x2, _x3) {
        return _addListenRelay2.apply(this, arguments);
      }

      return _addListenRelay;
    }()
    /**
     * Remove listen relay.
     *
     * @private
     * @param {string} id - peer identifier string.
     * @returns {void}
     */

  }, {
    key: "_removeListenRelay",
    value: function _removeListenRelay(id) {
      if (this._listenRelays.delete(id)) {
        // TODO: this should be responsibility of the connMgr
        this._listenOnAvailableHopRelays([id]);
      }
    }
    /**
     * Try to listen on available hop relay connections.
     * The following order will happen while we do not have enough relays.
     * 1. Check the metadata store for known relays, try to listen on the ones we are already connected.
     * 2. Dial and try to listen on the peers we know that support hop but are not connected.
     * 3. Search the network.
     *
     * @param {string[]} [peersToIgnore]
     * @returns {Promise<void>}
     */

  }, {
    key: "_listenOnAvailableHopRelays",
    value: function () {
      var _listenOnAvailableHopRelays2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var peersToIgnore,
            knownHopsToDial,
            _iterator2,
            _step2,
            _step2$value,
            id,
            metadataMap,
            supportsHop,
            _peerId2,
            connection,
            _i,
            _knownHopsToDial,
            peerId,
            cid,
            _iteratorAbruptCompletion,
            _didIteratorError,
            _iteratorError,
            _iterator,
            _step,
            provider,
            _peerId,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                peersToIgnore = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : [];

                if (!(this._listenRelays.size >= this.maxListeners)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                knownHopsToDial = []; // Check if we have known hop peers to use and attempt to listen on the already connected

                _iterator2 = _createForOfIteratorHelper(this._peerStore.metadataBook.data.entries());
                _context3.prev = 5;

                _iterator2.s();

              case 7:
                if ((_step2 = _iterator2.n()).done) {
                  _context3.next = 25;
                  break;
                }

                _step2$value = _slicedToArray(_step2.value, 2), id = _step2$value[0], metadataMap = _step2$value[1];

                if (!(this._listenRelays.has(id) || peersToIgnore.includes(id))) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt("continue", 23);

              case 11:
                supportsHop = metadataMap.get(HOP_METADATA_KEY); // Continue to next if it does not support Hop

                if (!(!supportsHop || uint8ArrayToString(supportsHop) !== HOP_METADATA_VALUE)) {
                  _context3.next = 14;
                  break;
                }

                return _context3.abrupt("continue", 23);

              case 14:
                _peerId2 = PeerId.createFromB58String(id);
                connection = this._connectionManager.get(_peerId2); // If not connected, store for possible later use.

                if (connection) {
                  _context3.next = 19;
                  break;
                }

                knownHopsToDial.push(_peerId2);
                return _context3.abrupt("continue", 23);

              case 19:
                _context3.next = 21;
                return this._addListenRelay(connection, id);

              case 21:
                if (!(this._listenRelays.size >= this.maxListeners)) {
                  _context3.next = 23;
                  break;
                }

                return _context3.abrupt("return");

              case 23:
                _context3.next = 7;
                break;

              case 25:
                _context3.next = 30;
                break;

              case 27:
                _context3.prev = 27;
                _context3.t0 = _context3["catch"](5);

                _iterator2.e(_context3.t0);

              case 30:
                _context3.prev = 30;

                _iterator2.f();

                return _context3.finish(30);

              case 33:
                _i = 0, _knownHopsToDial = knownHopsToDial;

              case 34:
                if (!(_i < _knownHopsToDial.length)) {
                  _context3.next = 43;
                  break;
                }

                peerId = _knownHopsToDial[_i];
                _context3.next = 38;
                return this._tryToListenOnRelay(peerId);

              case 38:
                if (!(this._listenRelays.size >= this.maxListeners)) {
                  _context3.next = 40;
                  break;
                }

                return _context3.abrupt("return");

              case 40:
                _i++;
                _context3.next = 34;
                break;

              case 43:
                _context3.prev = 43;
                _context3.next = 46;
                return namespaceToCid(RELAY_RENDEZVOUS_NS);

              case 46:
                cid = _context3.sent;
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context3.prev = 49;
                _iterator = _asyncIterator(this._libp2p.contentRouting.findProviders(cid));

              case 51:
                _context3.next = 53;
                return _iterator.next();

              case 53:
                if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
                  _context3.next = 66;
                  break;
                }

                provider = _step.value;

                if (provider.multiaddrs.length) {
                  _context3.next = 57;
                  break;
                }

                return _context3.abrupt("continue", 63);

              case 57:
                _peerId = provider.id;

                this._peerStore.addressBook.add(_peerId, provider.multiaddrs);

                _context3.next = 61;
                return this._tryToListenOnRelay(_peerId);

              case 61:
                if (!(this._listenRelays.size >= this.maxListeners)) {
                  _context3.next = 63;
                  break;
                }

                return _context3.abrupt("return");

              case 63:
                _iteratorAbruptCompletion = false;
                _context3.next = 51;
                break;

              case 66:
                _context3.next = 72;
                break;

              case 68:
                _context3.prev = 68;
                _context3.t1 = _context3["catch"](49);
                _didIteratorError = true;
                _iteratorError = _context3.t1;

              case 72:
                _context3.prev = 72;
                _context3.prev = 73;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context3.next = 77;
                  break;
                }

                _context3.next = 77;
                return _iterator.return();

              case 77:
                _context3.prev = 77;

                if (!_didIteratorError) {
                  _context3.next = 80;
                  break;
                }

                throw _iteratorError;

              case 80:
                return _context3.finish(77);

              case 81:
                return _context3.finish(72);

              case 82:
                _context3.next = 87;
                break;

              case 84:
                _context3.prev = 84;
                _context3.t2 = _context3["catch"](43);

                this._onError(_context3.t2);

              case 87:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 27, 30, 33], [43, 84], [49, 68, 72, 82], [73,, 77, 81]]);
      }));

      function _listenOnAvailableHopRelays() {
        return _listenOnAvailableHopRelays2.apply(this, arguments);
      }

      return _listenOnAvailableHopRelays;
    }()
    /**
     * @param {PeerId} peerId
     */

  }, {
    key: "_tryToListenOnRelay",
    value: function () {
      var _tryToListenOnRelay2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(peerId) {
        var connection;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this._libp2p.dial(peerId);

              case 3:
                connection = _context4.sent;
                _context4.next = 6;
                return this._addListenRelay(connection, peerId.toB58String());

              case 6:
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                this._onError(_context4.t0, "could not connect and listen on known hop relay ".concat(peerId.toB58String()));

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8]]);
      }));

      function _tryToListenOnRelay(_x4) {
        return _tryToListenOnRelay2.apply(this, arguments);
      }

      return _tryToListenOnRelay;
    }()
  }]);

  return AutoRelay;
}();

module.exports = AutoRelay;